import {Component, OnInit} from '@angular/core';
// import { Router } from '@angular/router';
import {Router} from "@angular/router";
import {StorageService} from "../../../../services/storage.service";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {Institution} from "../../../../store/entities/system-settings/institution/institution.model";
import {environment} from "../../../../../environments/environment";
import {AuthService} from "../../../../services/auth.service";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {


  mainMenu: {
    name: string,
    icon: string,
    iconType: 'SVG',
    route: string,
    permission: string[]
  }[];

  institution$: Institution

  hoverIndex: number = -1

  fullYear: number
  fileServer: string
  instLogo: string
  userProfile: any;

  constructor(
    private storageService: StorageService,
    private authService: AuthService
  ) {
    // this.userType = this.storageService.getItem('userType');
  }

  async ngOnInit(): Promise<void> {

    this.institution$ = this.storageService.getItem('institution');
    this.userProfile = this.storageService.getItem("profile")

    this.authService.monitorRefreshToken()
    this.mainMenu = [
      {
        name: 'Service Management',
        icon: 'service',
        iconType: 'SVG',
        route: '/service-management',
        permission: ['can_manage_services_management_card']
      },
      {
        name: 'Reports',
        icon: 'report',
        iconType: 'SVG',
        route: '/reports',
        permission: ['can_manage_reports_cards','can_view_service_report_card']
      },
      {
        name: 'Feedbacks',
        icon: 'feedback',
        iconType: 'SVG',
        route:'/feedback-processing/',
        permission: ['can_manage_feedback_cards']
      },
      {
        name: 'Institution Settings',
        icon: 'institution',
        iconType: 'SVG',
        route:'/settings',
        permission: ['can_manage_institution_settings_cards']
      },
      {
        name: 'System Settings',
        icon: 'settings',
        iconType: 'SVG',
        route:'/system-settings/',
        permission: ['can_manage_system_settings_cards']
      },
      {
        name: 'CMS',
        icon: 'settings',
        iconType: 'SVG',
        route:'/cms/',
        permission: ['can_manage_cms']
      },
      // {
      //   name: 'landing.kiosk',
      //   icon: 'kiosk',
      //   iconType: 'SVG',
      //   route:'/kiosk/',
      //   permission: ['can_manage_system_settings_cards']
      // },

    ]

    this.fullYear = new Date().getFullYear()
    this.fileServer = environment.FILE_SERVER_URL
    this.instLogo = `${this.fileServer}${this.institution$.institutionLogo}`
  }
}
